import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from '@angular/common/http';
import '@angular/common/locales/global/es';
import { LOCALE_ID, NgModule } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// I18N
import { JwtModule } from '@auth0/angular-jwt';
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { OAuthModule, OAuthStorage } from 'angular-oauth2-oidc';
import { NgxMaskModule } from 'ngx-mask';
import { QuillModule } from 'ngx-quill';
import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SpinnerComponent } from './core/components/basic/spinner/spinner.component';
import { HttpErrorInterceptor } from './core/interceptors/http-error.interceptor';
import { HttpSpinnerInterceptor } from './core/interceptors/http-spinner.interceptor';
import { HttpSuccessInterceptor } from './core/interceptors/http-success.interceptor';
import { HttpTokenInterceptor } from './core/interceptors/http-token.interceptor';
import { LOCAL_STORAGE_KEYS } from './core/models/local-storage-keys';
import { ScrollService } from './modules/dashboards/files/services/scroll.service';

// import { JwtModule } from "@auth0/angular-jwt";

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}

// Use localStorage to store oAuth tokens to allow multi tab without login every time
export function oAuthStorageFactory(): OAuthStorage {
  return localStorage;
}

export function tokenGetter() {
  return localStorage.getItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN);
}

@NgModule({
  declarations: [AppComponent, SpinnerComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    NgxMaskModule.forRoot(),
    MatSnackBarModule,
    MatProgressSpinnerModule,
    OAuthModule.forRoot({
      resourceServer: {
        allowedUrls: [environment.apiUrl],
        sendAccessToken: true,
      },
    }),
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter,
      }
    }),
    // i18n
    TranslateModule.forRoot({
      defaultLanguage: 'es',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    QuillModule.forRoot({
      customOptions: [
        { import: 'formats/font', whitelist: ['Aptos Narrow'] },
      ]
    }),
  ],
  providers: [
    TranslateService,
    ScrollService,
    { provide: LOCALE_ID, useValue: 'es' },
    { provide: HTTP_INTERCEPTORS, useClass: HttpTokenInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpSuccessInterceptor,
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpSpinnerInterceptor, multi: true },
    { provide: OAuthStorage, useFactory: oAuthStorageFactory }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
